import { render, staticRenderFns } from "./ItsBasePackAddress.vue?vue&type=template&id=655049e1&scoped=true&"
import script from "./ItsBasePackAddress.vue?vue&type=script&lang=js&"
export * from "./ItsBasePackAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655049e1",
  null
  
)

export default component.exports